import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import { CherryDevTheme } from '../CherrySoftware/CherryDevTheme';
import { CHERRY_SOFTWARE_CONTAINER_PROPS } from '../CherrySoftware/cherrySoftwareLayout';
import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';
import { PAGE_TITLE, PAGE_DESCRIPTION } from './sortilegioContent';
import {
  Hero,
  Diagnostico,
  PilarDigital,
  PilarPublicidad,
  MetaAds,
  PilarEmbajadores,
  Fases,
  Inversion,
  Cierre,
} from './components';

const LandingSortilegioInner = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', PAGE_DESCRIPTION);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: CHERRY_DEV.cream,
        fontFamily: '"Outfit", "Segoe UI", system-ui, sans-serif',
      }}
    >
      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS} paddingX={0} paddingY={{ xs: 3, sm: 4, md: 6 }}>
          <Hero />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Diagnostico />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <PilarDigital />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <PilarPublicidad />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <MetaAds />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <PilarEmbajadores />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <Fases />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Inversion />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <Cierre />
        </Container>
      </Box>
    </Box>
  );
};

const LandingSortilegio = () => (
  <CherryDevTheme>
    <LandingSortilegioInner />
  </CherryDevTheme>
);

LandingSortilegio.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingSortilegio;
